module.exports = __webpack_public_path__ + "static/img/apply_header_01_zh.f749b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apply_header_01_zh.png
// module id = 12gx
// module chunks = 34